<template>
  <div v-if="value">
    <b-card>
      <form>
        <string-form-field
          label="Titolo"
          :value="value.title"
          :disabled="disabled"
          :error="findError('title')"
          @input="propertyChanged('title', $event)"
        />

        <report-form-field
          label="Report"
          :value="value.reports"
          :disabled="disabled"
          multiple
          sortable
          :error="findError('reports')"
          @input="propertyChanged('reports', $event)"
        />
      </form>
    </b-card>
  </div>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
